/**
 * Zustand Stores
 *
 * Centralized state management using Zustand.
 */

export {
  useMatterEstateAdminStore,
  useSelectedMatterId,
  useIsPanelOpen,
  useMatterPanelActions,
  type MatterTab
} from './matter-estate-admin-store';

export {
  useMatterListNavigationStore,
  getMatterListNavigationActions,
  isMatterListId
} from './matter-list-navigation-store';

export {
  useAccountNavigationStore,
  useAccountReturnPath,
  getAccountNavigationActions
} from './account-navigation-store';

export {
  useScrollPositionStore,
  getScrollPositionActions
} from './scroll-position-store';

export { useIntercomStore, getIntercomActions } from './intercom-store';

export {
  useRecordingSessionStore,
  useIsRecording,
  useIsPaused,
  useIsMinimised,
  useElapsedSeconds,
  useRecordingMatterId,
  useRecordingMatterName,
  useRecordingMatterReference,
  useActiveDeviceLabel,
  useStoredBytes,
  useIsMiniBarVisible,
  useRecordingSessionActions,
  getRecordingSessionActions,
  getRecordingSessionState,
  getElapsedMs,
  getElapsedSeconds,
  type PauseRange
} from './recording-session-store';

export {
  useRecordingUploadStore,
  useUploadRecordingId,
  useRecordingUploadActions,
  getRecordingUploadActions,
  getRecordingUploadState
} from './recording-upload-store';

export {
  useGettingStartedStore,
  useGettingStartedInitiated,
  useGettingStartedIsInitiated,
  useGettingStartedSetupFirmComplete,
  useGettingStartedHydrated,
  useDismissedOnboardingSteps,
  getGettingStartedActions,
  getSetupFirmStepLabel,
  CANONICAL_STEPS as GETTING_STARTED_STEPS,
  TOTAL_STEPS as GETTING_STARTED_TOTAL_STEPS,
  GETTING_STARTED_CHECKLIST_STEPS,
  type GettingStartedStepKey,
  type GettingStartedStepDescriptor
} from './getting-started-store';
